import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';

@CopyProperties()
export class Program {
  id: number;
  name: string;
  tradeCode: string;
  vsdCode: string;
  buyMinValue: number;
  sellMin: number;
  switchMin: number;
  holdingMin: number;
  holdingVolume: number;
  percentFeeAmc: number;
  percentFeeFund: number;
  isBuy: boolean;
  isSell: boolean;
  isTransfer: boolean;
  product: any;
  supervisoryBankAccount: any;
  constructor(
    params?: any
  ) {
    this.id = 0;
    this.product = null;
    this.supervisoryBankAccount = null;
    this.name = '';
    this.tradeCode = '';
    this.vsdCode = '';
    this.buyMinValue = 0;
    this.sellMin = 0;
    this.switchMin = 0;
    this.holdingMin = 0;
    this.holdingVolume = 0;
    this.percentFeeAmc = 0;
    this.percentFeeFund = 0;
    this.isBuy = true;
    this.isSell = true;
    this.isTransfer = false;
  }
}
